/**
 * Extracts the YouTube video ID from a given URL.
 *
 * @param {string} value - The YouTube video URL from which to extract the video ID.
 * @returns {string|boolean} - The extracted YouTube video ID if found, otherwise `false`.
 * @example
 * // Extracts ID from a standard YouTube URL
 * const videoId = getYoutube('https://www.youtube.com/watch?v=dQw4w9WgXcQ')
 * console.log(videoId) // Output: 'dQw4w9WgXcQ'
 *
 * // Extracts ID from a shortened YouTube URL
 * const videoId = getYoutube('https://youtu.be/dQw4w9WgXcQ')
 * console.log(videoId) // Output: 'dQw4w9WgXcQ'
 *
 * // Returns false for non-YouTube URLs
 * const videoId = getYoutube('https://example.com/somevideo')
 * console.log(videoId) // Output: false
 */
const getYoutube = (value) => {
  var regEx =
    '^(?:https?:)?//[^/]*(?:youtube(?:-nocookie)?.com|youtu.be).*[=/]([-\\w]{11})(?:\\?|=|&|$)'
  var matches = value.match(regEx)
  return matches ? matches[1] : false
}

export default getYoutube